// src/config/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBSHle2xaCr3T-qL9xNwGBOamKfTOWNJLE",
  authDomain: "soneyraya-b7342.firebaseapp.com",
  databaseURL: "https://soneyraya-b7342-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "soneyraya-b7342",
  storageBucket: "soneyraya-b7342.firebasestorage.app",
  messagingSenderId: "693279811941",
  appId: "1:693279811941:web:d4ea920f4588fa6901598c",
  measurementId: "G-E2KC2CZHK4"
};


// Inisialisasi Firebase
const app = initializeApp(firebaseConfig);

// Export service yang mau dipakai
export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export const storage = getStorage(app);
export { firebaseConfig };
export default app;
